import qs from 'qs'
import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken, getBaseUrl
} from '../../utils'

export const fetchAcademicYears = async (orgId, token) => {
  const url = `${getApiBaseUrlWithOrg(orgId)}/academic_years`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchMentorMasterCourses = async (
  orgId,
  token,
  academicYearId
) => {
  const params = qs.stringify({
    q: {
      academic_year_id_eq: academicYearId
    }
  })

  const url = `${getApiBaseUrlWithOrg(orgId)}/mentor/master_courses?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchAllMentorMasterCourses = async (
  orgId,
  token
) => {

  const url = `${getApiBaseUrlWithOrg(orgId)}/mentor/master_courses`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchActivityCourseJourneys = async (
  orgId,
  token,
  activityCourseId
) => {
  const url = `${getApiBaseUrlWithOrg(
    orgId
  )}/mentor/master_courses/${activityCourseId}/courses`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    const data = await response.json()
    return data
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const createNewCourse = async (
  apiData,
  selectedCourseLevel,
  selectedFrameworkSubject,
  courseName,
  abbreviation,
  courseColor,
  selectedAcademicYearId
) => {
  const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/mentor/master_courses`
  const data = {
    master_course: {
      name: courseName,
      abbreviation: abbreviation,
      grade_level_id: selectedCourseLevel.id,
      framework_subject_id: selectedFrameworkSubject.id,
      academic_year_id: selectedAcademicYearId,
      color: courseColor.replace('#', '')
    }
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const deleteMentorActivityCourse = async (apiData, activityCourseId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const editMentorActivityCourse = async (
  apiData,
  courseName,
  abbreviation,
  courseColor,
  activityCourse
) => {
  const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/mentor/master_courses/${
    activityCourse.id
  }`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          master_course: {
            name: courseName,
            abbreviation: abbreviation,
            color: courseColor.replace('#', '')
          }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const publishActivity = async (apiData, levelId, activityQuestId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/publish`
  try {
    checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
  } catch (error) {}
}

export const returnPublishedActivityToDraft = async (
  apiData,
  levelId,
  activityQuestId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/return_to_draft`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (error) {}
}

export const publishJourney = async (apiData, activityCourseId, journeyId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/publish`
  try {
    checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
  } catch (error) {}
}

export const fetchCloneableMasterCourses = async (
  orgId,
  token
) => {

  const url = `${getApiBaseUrlWithOrg(orgId)}/mentor/master_courses_cloner`

  try {
    let response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    let resJSON = await response.json()
    if (response.status === 403) {
      throw new Error('ERROR 403!!!!!!!')
    }
    return resJSON
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const cloneMasterCourse = async (
  apiData,
  masterCourseId,
  academicYearId,
  courseName,
  abbreviation,
  color,
  frameworkSubjectId,
  gradeLevelId
) => {
  const params = qs.stringify({
    q: {
      academic_year_id_eq: academicYearId,
      name: courseName,
      abbreviation: abbreviation,
      color: color.replace('#', ''),
      framework_subject_id: frameworkSubjectId,
      grade_level_id: gradeLevelId
    }
  })

  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${masterCourseId}/master_courses_cloner?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const fetchCloneableJourneys = async (
  orgId,
  token,
  masterCourseId
) => {
  const params = qs.stringify({
    q: {
      master_course_id: masterCourseId
    }
  })
  const url = `${getApiBaseUrlWithOrg(
    orgId
  )}/mentor/courses_cloner?${params}`

  console.log('url', url)
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const cloneCourse = async (
  apiData,
  activityCourseId,
  selectedJourneyId,
  name,
  description,
  color
) => {
  const params = qs.stringify({
    q: {
      master_course_id: activityCourseId,
      name: name,
      description: description,
      color: color
    }
  })

  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/courses/${selectedJourneyId}/courses_cloner?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const fetchOrgFlags = async (
  orgId,
  token
) => {

  const url = getBaseUrl() + '/api/organizations/' + orgId

  try {
    let response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )
    return await response.json()
  } catch (err) {
    throw new Error(err)
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/API.js